// MobileContext.js
import React, { createContext, useContext } from 'react';
import { useMediaQuery } from '@mui/material';

const MobileContext = createContext();

export const MobileProvider = ({ children }) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>
  );
};

export const useIsMobile = () => {
  return useContext(MobileContext);
};

/**
 * How to use
 * 1. import { MobileProvider } from 'src/contexts/mobile-context';
 * Using in wrapper folder: <MobileProvider> ... </MobileProvider>
 * 
 * 2. import { useIsMobile } from 'src/contexts/mobile-context';
 * Using in pages folder
 * const isMobile = useIsMobile();
 * <Container maxWidth="xl" sx={isMobile ? { px: 1 } : {px: 3}}>
 * 
 * Please preference to wapper/account.js and pages/dashboard/account.js
 */